export const NAME = 'MigratorApproval';

export class MigratorApprovalError extends Error {
  constructor(message?: string) {
    super(message || 'migrator not approved');
    this.name = NAME;
  }
}
